import { LocationType } from './v1/ApiModel';
import { DestinationTypes } from '../constants';

export type SelectOption = {
  value: string;
  label: string;
  location: LocationType;
  type: DestinationTypes;
};

export enum TripTypes {
  'roundTrip' = 'round-trip',
  'oneWay' = 'one-way',
  'multiCity' = 'multi-city',
}

export enum Currencies {
  'thb' = 'THB',
  'usd' = 'USD',
  'cny' = 'CNY',
  'inr' = 'INR',
}

export enum Languages {
  'english' = 'en',
  'thai' = 'th',
  'chinese' = 'zh',
}

export type FormType = {
  tripType: TripTypes;
  adults: number;
  children: number;
  childrenAges?: { age: number }[];
  infants: number;
  infantsAges?: { age: number }[];
  bounds: {
    origin: SelectOption | null;
    destination: SelectOption | null;
    departure: string;
    return: string;
  }[];
  currency: Currencies;
  promoCode: string;
  lowestFare: boolean;
};

export type PassengersType = keyof Pick<FormType, 'adults' | 'children' | 'infants'>;

export type BoundType = FormType['bounds'][number];

export type DatesType = keyof Pick<BoundType, 'departure' | 'return'>;

export type LocationsType = keyof Pick<BoundType, 'origin' | 'destination'>;

export const newBound: BoundType = {
  origin: null,
  destination: null,
  departure: '',
  return: '',
};

export const initialState: FormType = {
  tripType: TripTypes.roundTrip,
  adults: 1,
  children: 0,
  infants: 0,
  bounds: [newBound],
  currency: Currencies.thb,
  promoCode: '',
  lowestFare: false,
};
